import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteMaterialTypeMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (materialId) => {
      return httpClient.delete(`/admin/materialtypes/${materialId}`)
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      showSuccessNotification({
        title: "Deleted",
        message: "Material type has been deleted",
      })
      await queryClient.invalidateQueries({
        queryKey: ["materialTypes"],
      })
    },
  })
}
